import React, { CSSProperties } from 'react';
import { colors } from '../colors';

interface Props {
  error: string | undefined;
  visible: boolean | undefined;
}

export const FormErrorMessage = ({ error, visible }: Props) => {
  if (!error || !visible) {
    return null;
  }

  const errorStyle: CSSProperties = {
    marginLeft: '15px',
    color: colors.red,
    fontSize: '16px',
    marginTop: '8px',
    marginBottom: '8px',
    fontWeight: '600',
  };

  return <p style={errorStyle}>{error}</p>;
};
